import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { ArrowRight, DoorOpen, Maximize, Ruler, Settings } from "lucide-react";
const services = [{
  title: "בית חולים בילינסון (מרכז רפואי רבין)",
  description: "מרכז רפואי מוביל בפתח תקווה המעניק שירותי רפואה מתקדמים. אנו מספקים ליווי סיעודי צמוד למאושפזים בבילינסון, הכולל השגחה פרטית, סיוע בניידות ותמיכה רגשית למטופל ולמשפחתו ברגעים הקריטיים ביותר, תוך תיאום מלא עם הצוות הרפואי במקום.",
  icon: DoorOpen,
  link: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "מרכז רפואי פלזנשטיין",
  description: "מוסד רפואי ייחודי המתמחה במחקר וטיפול בפתח תקווה. שירותי הסיעוד שלנו במרכז פלזנשטיין מותאמים אישית לצרכי המטופל, עם דגש על מקצועיות ללא פשרות, זמינות מיידית של מטפל מוסמך ומתן מענה אנושי וחם המקל על תהליך ההחלמה והשהות במוסד.",
  icon: Settings,
  link: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "ליווי סיעודי בבתי חולים",
  description: "זקוקים לעזרה מיידית בבית החולים? אנו מציעים פתרון מהיר ומקצועי הכולל השגחה של 24 שעות ביממה. המטפלים שלנו מנוסים בעבודה בסביבה בית חולים ומבטיחים שהיקיר שלכם לעולם לא יישאר לבד, תוך שמירה על כבודו ורווחתו האישית.",
  icon: Ruler,
  link: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "סיוע לאחר שחרור מבית חולים",
  description: "המעבר מבית החולים חזרה הביתה בפתח תקווה דורש היערכות מיוחדת. אנו מספקים מטפלים סיעודיים המלווים את המטופל מרגע השחרור, מסייעים בהתארגנות בבית, במתן תרופות ובשיקום ראשוני, כדי להבטיח רצף טיפולי בטוח ורגוע בבית.",
  icon: Maximize,
  link: "/NursingCareProviderPetahTikvaWithinHoursPage"
}];
export default function RelatedServices() {
  return <section data-section-id="260538" id="מיקומים-וביתנות-בפתח-תקווה" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-primary mb-4">
            מיקומים וביתנות בפתח תקווה
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default">
            שירותי סיעוד מקצועיים וזמינות מיידית במרכזים הרפואיים המובילים בפתח תקווה. אנו כאן כדי להעניק לכם שקט נפשי וטיפול מסור.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className="group overflow-hidden border-border/50 shadow-md hover:shadow-xl transition-all duration-300 bg-card rounded-lg">
              <div className="p-6 sm:p-8 flex flex-col h-full">
                <div className="mb-6 inline-flex p-3.5 rounded-lg bg-accent text-accent-foreground group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300 self-start">
                  <service.icon className="size-6" />
                </div>
                
                <h3 className="text-xl sm:text-2xl font-bold font-default text-foreground mb-3">
                  {service.title}
                </h3>
                
                <p className="text-muted-foreground mb-8 flex-1 leading-relaxed font-default">
                  {service.description}
                </p>
                
                <div className="mt-auto pt-5 border-t border-border/40">
                  <Link to={service.link} className="inline-flex items-center text-sm font-bold font-default text-primary hover:text-secondary transition-colors group/link">
                    פתרון מיידי
                    <ArrowRight className="mr-2 size-4 rotate-180 transition-transform group-hover/link:-translate-x-1" />
                  </Link>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}